// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13282(34033a5219)-C22/10/2026-09:36:12-B22/10/2026-10:11:43' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13282(34033a5219)-C22/10/2026-09:36:12-B22/10/2026-10:11:43",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13282",
  shortHash: "34033a5219",
  longHash: "34033a5219e0ec35b1bb10b03ccdbd611503cc05",
  dateCommit: "22/10/2026-09:36:12",
  dateBuild: "22/10/2026-10:11:43",
  buildType: "Ansible",
  } ;
